






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-fire',

})
export default class IFire extends Vue {

  @Prop({type: [String], default: '#E6E4EA'}) protected color!: string

  click() {
    this.$emit('click')
  }
}

